import {
  getLeoUuid,
  LeoUUID,
  getInt32,
  getList,
  getObject,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { TableFilter, TableFilterDTO, TableFilterEnums } from "../types/tableFilter";
import { Code, CodeDTO } from "../types/code";
/* eslint-disable import/export */
export abstract class GetPaginatedOpenEndedResponsesRPC implements
  LeoRPC<GetPaginatedOpenEndedResponsesRPC.Request, GetPaginatedOpenEndedResponsesRPC.Response, GetPaginatedOpenEndedResponsesRPC.Errors.Errors>
{
  abstract execute(
    request: GetPaginatedOpenEndedResponsesRPC.Request
  ): Promise<LeoRPCResult<GetPaginatedOpenEndedResponsesRPC.Response, GetPaginatedOpenEndedResponsesRPC.Errors.Errors>>;
}

export namespace GetPaginatedOpenEndedResponsesRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  
  export namespace RequestEnums {
    export namespace OpenEndedQuestionType {
      export interface IndividualDTO {
        case: string;
      }
      
      export class Individual {
        readonly isOpenEndedQuestionTypeIndividual: boolean = true;
      
      
      
      
      
        toDTO(): IndividualDTO {
          const dto: IndividualDTO = {
            case: "INDIVIDUAL",
          };
          return dto;
        }
        }
      
      Individual.prototype.toString = function toString(): string {
        return `OpenEndedQuestionType.INDIVIDUAL()`;
      };
      
      
      export namespace GroupEnums {
        export namespace ChildQuestionType {
          export interface OpenEndedDTO {
            case: string;
          }
          
          export class OpenEnded {
            readonly isChildQuestionTypeOpenEnded: boolean = true;
          
          
          
          
          
            toDTO(): OpenEndedDTO {
              const dto: OpenEndedDTO = {
                case: "OPEN_ENDED",
              };
              return dto;
            }
            }
          
          OpenEnded.prototype.toString = function toString(): string {
            return `ChildQuestionType.OPEN_ENDED()`;
          };
          
          export interface GridDTO {
            case: string;
            rowCode: CodeDTO;
            columnCode: CodeDTO;
          }
          
          export class Grid {
            readonly isChildQuestionTypeGrid: boolean = true;
          
            readonly rowCode: Code;
            readonly columnCode: Code;
          
          
            constructor(
            rowCode: Code, 
            columnCode: Code
            ) {
              this.rowCode = rowCode;
              this.columnCode = columnCode;
            }
          
            static fromDTO(dto: GridDTO): Grid {
              const rowCode = Code.fromDTO(getObject(dto, "rowCode", InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridRowCodeError));
              const columnCode = Code.fromDTO(getObject(dto, "columnCode", InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridColumnCodeError));
              return new Grid(
                rowCode,
                columnCode
              );
            }
          
            toDTO(): GridDTO {
              const dto: GridDTO = {
                case: "GRID",
                  rowCode: this.rowCode.toDTO(),
                  columnCode: this.columnCode.toDTO()
              };
              return dto;
            }
            }
          
          Grid.prototype.toString = function toString(): string {
            return `ChildQuestionType.GRID(rowCode='${this.rowCode}',columnCode='${this.columnCode}')`;
          };
          
        
          export type ChildQuestionType = OpenEnded | Grid;
        
          export type ChildQuestionTypeDTO = OpenEndedDTO | GridDTO;
        
          export const fromDTO = (dto: ChildQuestionTypeDTO): ChildQuestionType => {
            switch (dto.case) {
              case "OPEN_ENDED":
                  return new OpenEnded();
              case "GRID":
                  return Grid.fromDTO(dto as GridDTO);
              default:
                throw new InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeError(
                    `Case ${dto.case} is not valid case of ChildQuestionType.`
                );
            }
          };
        }
        
      }
      export interface GroupDTO {
        case: string;
        childQuestionCode: CodeDTO;
        childQuestionType: GroupEnums.ChildQuestionType.ChildQuestionTypeDTO;
      }
      
      export class Group {
        readonly isOpenEndedQuestionTypeGroup: boolean = true;
      
        readonly childQuestionCode: Code;
        readonly childQuestionType: GroupEnums.ChildQuestionType.ChildQuestionType;
      
      
        constructor(
        childQuestionCode: Code, 
        childQuestionType: GroupEnums.ChildQuestionType.ChildQuestionType
        ) {
          this.childQuestionCode = childQuestionCode;
          this.childQuestionType = childQuestionType;
        }
      
        static fromDTO(dto: GroupDTO): Group {
          const childQuestionCode = Code.fromDTO(getObject(dto, "childQuestionCode", InvalidRequestOpenEndedQuestionTypeGroupChildQuestionCodeError));
          const childQuestionType = GroupEnums.ChildQuestionType.fromDTO(getObject(dto, "childQuestionType", InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeError));
          return new Group(
            childQuestionCode,
            childQuestionType
          );
        }
      
        toDTO(): GroupDTO {
          const dto: GroupDTO = {
            case: "GROUP",
              childQuestionCode: this.childQuestionCode.toDTO(),
              childQuestionType: this.childQuestionType.toDTO()
          };
          return dto;
        }
        }
      
      Group.prototype.toString = function toString(): string {
        return `OpenEndedQuestionType.GROUP(childQuestionCode='${this.childQuestionCode}',childQuestionType='${this.childQuestionType}')`;
      };
      
      export interface GridDTO {
        case: string;
        rowCode: CodeDTO;
        columnCode: CodeDTO;
      }
      
      export class Grid {
        readonly isOpenEndedQuestionTypeGrid: boolean = true;
      
        readonly rowCode: Code;
        readonly columnCode: Code;
      
      
        constructor(
        rowCode: Code, 
        columnCode: Code
        ) {
          this.rowCode = rowCode;
          this.columnCode = columnCode;
        }
      
        static fromDTO(dto: GridDTO): Grid {
          const rowCode = Code.fromDTO(getObject(dto, "rowCode", InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridRowCodeError));
          const columnCode = Code.fromDTO(getObject(dto, "columnCode", InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridColumnCodeError));
          return new Grid(
            rowCode,
            columnCode
          );
        }
      
        toDTO(): GridDTO {
          const dto: GridDTO = {
            case: "GRID",
              rowCode: this.rowCode.toDTO(),
              columnCode: this.columnCode.toDTO()
          };
          return dto;
        }
        }
      
      Grid.prototype.toString = function toString(): string {
        return `OpenEndedQuestionType.GRID(rowCode='${this.rowCode}',columnCode='${this.columnCode}')`;
      };
      
    
      export type OpenEndedQuestionType = Individual | Group | Grid;
    
      export type OpenEndedQuestionTypeDTO = IndividualDTO | GroupDTO | GridDTO;
    
      export const fromDTO = (dto: OpenEndedQuestionTypeDTO): OpenEndedQuestionType => {
        switch (dto.case) {
          case "INDIVIDUAL":
              return new Individual();
          case "GROUP":
              return Group.fromDTO(dto as GroupDTO);
          case "GRID":
              return Grid.fromDTO(dto as GridDTO);
          default:
            throw new InvalidRequestOpenEndedQuestionTypeError(
                `Case ${dto.case} is not valid case of OpenEndedQuestionType.`
            );
        }
      };
    }
    
  }
  export interface RequestDTO {
    projectId: string;
    surveyId: string;
    surveyViewId: string;
    surveyQuestionViewId: string;
    pageIndex: number;
    itemsPerPage: number;
    filters: TableFilterDTO[];
    fieldCode: CodeDTO;
    openEndedQuestionType: RequestEnums.OpenEndedQuestionType.OpenEndedQuestionTypeDTO;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetPaginatedOpenEndedResponsesRPCRequest: boolean = true;
  
    readonly projectId: LeoUUID;
    readonly surveyId: LeoUUID;
    readonly surveyViewId: LeoUUID;
    readonly surveyQuestionViewId: LeoUUID;
    readonly pageIndex: number;
    readonly itemsPerPage: number;
    readonly filters: TableFilter[];
    readonly fieldCode: Code;
    readonly openEndedQuestionType: RequestEnums.OpenEndedQuestionType.OpenEndedQuestionType;
  
    static readonly constraints = {
      "pageIndex": {
        "minValue": 0,
      },
      "filters": {
        "maxSize": 5,
      },
    }
  
    constructor(
    projectId: LeoUUID, 
    surveyId: LeoUUID, 
    surveyViewId: LeoUUID, 
    surveyQuestionViewId: LeoUUID, 
    pageIndex: number, 
    itemsPerPage: number, 
    filters: TableFilter[], 
    fieldCode: Code, 
    openEndedQuestionType: RequestEnums.OpenEndedQuestionType.OpenEndedQuestionType
    ) {
      this.projectId = projectId;
      this.surveyId = surveyId;
      this.surveyViewId = surveyViewId;
      this.surveyQuestionViewId = surveyQuestionViewId;
      Request.validatePageIndex(pageIndex);
      this.pageIndex = pageIndex;
      this.itemsPerPage = itemsPerPage;
      Request.validateFilters(filters);
      this.filters = filters;
      this.fieldCode = fieldCode;
      this.openEndedQuestionType = openEndedQuestionType;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const projectId = getLeoUuid(dto, "projectId", InvalidRequestProjectIdError);
      const surveyId = getLeoUuid(dto, "surveyId", InvalidRequestSurveyIdError);
      const surveyViewId = getLeoUuid(dto, "surveyViewId", InvalidRequestSurveyViewIdError);
      const surveyQuestionViewId = getLeoUuid(dto, "surveyQuestionViewId", InvalidRequestSurveyQuestionViewIdError);
      const pageIndex = getInt32(dto, "pageIndex", InvalidRequestPageIndexError);
      const itemsPerPage = getInt32(dto, "itemsPerPage", InvalidRequestItemsPerPageError);
      const filters = getList<TableFilterDTO, TableFilter>(
        dto,
        "filters",
        TableFilter.fromDTO,
        InvalidRequestFiltersError
      );
      const fieldCode = Code.fromDTO(getObject(dto, "fieldCode", InvalidRequestFieldCodeError));
      const openEndedQuestionType = RequestEnums.OpenEndedQuestionType.fromDTO(getObject(dto, "openEndedQuestionType", InvalidRequestOpenEndedQuestionTypeError));
      return new Request(
        projectId,
        surveyId,
        surveyViewId,
        surveyQuestionViewId,
        pageIndex,
        itemsPerPage,
        filters,
        fieldCode,
        openEndedQuestionType
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          projectId: this.projectId.toDTO(),
          surveyId: this.surveyId.toDTO(),
          surveyViewId: this.surveyViewId.toDTO(),
          surveyQuestionViewId: this.surveyQuestionViewId.toDTO(),
          pageIndex: this.pageIndex,
          itemsPerPage: this.itemsPerPage,
          filters: this.filters.map((e: TableFilter) => { return e.toDTO() }),
          fieldCode: this.fieldCode.toDTO(),
          openEndedQuestionType: this.openEndedQuestionType.toDTO()
      };
      return dto;
    }
    private static validatePageIndex = (pageIndex: number): void => {
      if(pageIndex < 0) {
        throw new InvalidRequestPageIndexMinValueError(
          0,
          `Attribute pageIndex has value ${pageIndex}. Min value is 0.`
        );
      }
    }
    private static validateFilters = (filters: TableFilter[]): void => {
      if(filters.length > 5) {
        throw new InvalidRequestFiltersMaxSizeError(
          5,
          `Attribute filters is too long. Size is ${filters.length}. Max size is 5.`
        );
      }
    }
    
  }
  
  Request.prototype.toString = function toString(): string {
    return `GetPaginatedOpenEndedResponsesRPC(projectId='${this.projectId}',surveyId='${this.surveyId}',surveyViewId='${this.surveyViewId}',surveyQuestionViewId='${this.surveyQuestionViewId}',pageIndex='${this.pageIndex}',itemsPerPage='${this.itemsPerPage}',filters='${this.filters}',fieldCode='${this.fieldCode}',openEndedQuestionType='${this.openEndedQuestionType}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    openEndedResponses: string[];
    totalItems: number;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetPaginatedOpenEndedResponsesResponse: boolean = true;
  
    readonly openEndedResponses: string[];
    readonly totalItems: number;
  
  
    constructor(
    openEndedResponses: string[], 
    totalItems: number
    ) {
      this.openEndedResponses = openEndedResponses;
      this.totalItems = totalItems;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const openEndedResponses = getList<string, string>(
        dto,
        "openEndedResponses",
        (e: string) => e,
        InvalidResponseOpenEndedResponsesError
      );
      const totalItems = getInt32(dto, "totalItems", InvalidResponseTotalItemsError);
      return new Response(
        openEndedResponses,
        totalItems
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          openEndedResponses: this.openEndedResponses,
          totalItems: this.totalItems
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetPaginatedOpenEndedResponses(openEndedResponses='${this.openEndedResponses}',totalItems='${this.totalItems}')`;
  };
  

  export enum RPCError {
    InvalidProjectId = "INVALID_PROJECT_ID",
    InvalidSurveyId = "INVALID_SURVEY_ID",
    InvalidSurveyViewId = "INVALID_SURVEY_VIEW_ID",
    InvalidQuestionViewId = "INVALID_QUESTION_VIEW_ID",
    InvalidPageIndex = "INVALID_PAGE_INDEX",
    DeletedColumnFilter = "DELETED_COLUMN_FILTER",
    IncorrectQuestionType = "INCORRECT_QUESTION_TYPE"
  }

  export namespace Errors {
    
    export interface InvalidProjectIdDTO {
      code: string;
    }
    
    export class InvalidProjectId extends LeoRPCError<RPCError> {
      readonly isInvalidProjectId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidProjectId;
        super(code);
      }
    
    
      toDTO(): InvalidProjectIdDTO {
        const dto: InvalidProjectIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidProjectId.prototype.toString = function toString(): string {
      return `GetPaginatedOpenEndedResponsesRPC.INVALID_PROJECT_ID()`;
    };
    
    
    export interface InvalidSurveyIdDTO {
      code: string;
    }
    
    export class InvalidSurveyId extends LeoRPCError<RPCError> {
      readonly isInvalidSurveyId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidSurveyId;
        super(code);
      }
    
    
      toDTO(): InvalidSurveyIdDTO {
        const dto: InvalidSurveyIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidSurveyId.prototype.toString = function toString(): string {
      return `GetPaginatedOpenEndedResponsesRPC.INVALID_SURVEY_ID()`;
    };
    
    
    export interface InvalidSurveyViewIdDTO {
      code: string;
    }
    
    export class InvalidSurveyViewId extends LeoRPCError<RPCError> {
      readonly isInvalidSurveyViewId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidSurveyViewId;
        super(code);
      }
    
    
      toDTO(): InvalidSurveyViewIdDTO {
        const dto: InvalidSurveyViewIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidSurveyViewId.prototype.toString = function toString(): string {
      return `GetPaginatedOpenEndedResponsesRPC.INVALID_SURVEY_VIEW_ID()`;
    };
    
    
    export interface InvalidQuestionViewIdDTO {
      code: string;
    }
    
    export class InvalidQuestionViewId extends LeoRPCError<RPCError> {
      readonly isInvalidQuestionViewId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidQuestionViewId;
        super(code);
      }
    
    
      toDTO(): InvalidQuestionViewIdDTO {
        const dto: InvalidQuestionViewIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidQuestionViewId.prototype.toString = function toString(): string {
      return `GetPaginatedOpenEndedResponsesRPC.INVALID_QUESTION_VIEW_ID()`;
    };
    
    
    export interface InvalidPageIndexDTO {
      code: string;
    }
    
    export class InvalidPageIndex extends LeoRPCError<RPCError> {
      readonly isInvalidPageIndex: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidPageIndex;
        super(code);
      }
    
    
      toDTO(): InvalidPageIndexDTO {
        const dto: InvalidPageIndexDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidPageIndex.prototype.toString = function toString(): string {
      return `GetPaginatedOpenEndedResponsesRPC.INVALID_PAGE_INDEX()`;
    };
    
    
    export interface DeletedColumnFilterDTO {
      code: string;
    }
    
    export class DeletedColumnFilter extends LeoRPCError<RPCError> {
      readonly isDeletedColumnFilter: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.DeletedColumnFilter;
        super(code);
      }
    
    
      toDTO(): DeletedColumnFilterDTO {
        const dto: DeletedColumnFilterDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    DeletedColumnFilter.prototype.toString = function toString(): string {
      return `GetPaginatedOpenEndedResponsesRPC.DELETED_COLUMN_FILTER()`;
    };
    
    
    export interface IncorrectQuestionTypeDTO {
      code: string;
    }
    
    export class IncorrectQuestionType extends LeoRPCError<RPCError> {
      readonly isIncorrectQuestionType: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.IncorrectQuestionType;
        super(code);
      }
    
    
      toDTO(): IncorrectQuestionTypeDTO {
        const dto: IncorrectQuestionTypeDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    IncorrectQuestionType.prototype.toString = function toString(): string {
      return `GetPaginatedOpenEndedResponsesRPC.INCORRECT_QUESTION_TYPE()`;
    };
    

    export type Errors = InvalidProjectId | InvalidSurveyId | InvalidSurveyViewId | InvalidQuestionViewId | InvalidPageIndex | DeletedColumnFilter | IncorrectQuestionType;
    export type ErrorsDTO = InvalidProjectIdDTO | InvalidSurveyIdDTO | InvalidSurveyViewIdDTO | InvalidQuestionViewIdDTO | InvalidPageIndexDTO | DeletedColumnFilterDTO | IncorrectQuestionTypeDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidProjectId:
          return new InvalidProjectId();
        case RPCError.InvalidSurveyId:
          return new InvalidSurveyId();
        case RPCError.InvalidSurveyViewId:
          return new InvalidSurveyViewId();
        case RPCError.InvalidQuestionViewId:
          return new InvalidQuestionViewId();
        case RPCError.InvalidPageIndex:
          return new InvalidPageIndex();
        case RPCError.DeletedColumnFilter:
          return new DeletedColumnFilter();
        case RPCError.IncorrectQuestionType:
          return new IncorrectQuestionType();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestProjectIdError extends GetPaginatedOpenEndedResponsesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestProjectIdError";
  }
}

export class InvalidRequestSurveyIdError extends GetPaginatedOpenEndedResponsesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestSurveyIdError";
  }
}

export class InvalidRequestSurveyViewIdError extends GetPaginatedOpenEndedResponsesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestSurveyViewIdError";
  }
}

export class InvalidRequestSurveyQuestionViewIdError extends GetPaginatedOpenEndedResponsesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestSurveyQuestionViewIdError";
  }
}

export class InvalidRequestPageIndexError extends GetPaginatedOpenEndedResponsesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestPageIndexError";
  }
}

export class InvalidRequestPageIndexMinValueError extends InvalidRequestPageIndexError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestPageIndexMinValueError";
  }
}

export class InvalidRequestItemsPerPageError extends GetPaginatedOpenEndedResponsesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestItemsPerPageError";
  }
}

export class InvalidRequestFiltersError extends GetPaginatedOpenEndedResponsesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestFiltersError";
  }
}

export class InvalidRequestFiltersMaxSizeError extends InvalidRequestFiltersError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestFiltersMaxSizeError";
  }
}

export class InvalidRequestFieldCodeError extends GetPaginatedOpenEndedResponsesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestFieldCodeError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeError extends GetPaginatedOpenEndedResponsesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeIndividualError extends InvalidRequestOpenEndedQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeIndividualError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeGroupError extends InvalidRequestOpenEndedQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeGroupError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeGroupChildQuestionCodeError extends InvalidRequestOpenEndedQuestionTypeGroupError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeGroupChildQuestionCodeError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeError extends InvalidRequestOpenEndedQuestionTypeGroupError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeOpenEndedError extends InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeOpenEndedError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridError extends InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridRowCodeError extends InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridRowCodeError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridColumnCodeError extends InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeGroupChildQuestionTypeGridColumnCodeError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeGridError extends InvalidRequestOpenEndedQuestionTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeGridError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeGridRowCodeError extends InvalidRequestOpenEndedQuestionTypeGridError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeGridRowCodeError";
  }
}

export class InvalidRequestOpenEndedQuestionTypeGridColumnCodeError extends InvalidRequestOpenEndedQuestionTypeGridError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestOpenEndedQuestionTypeGridColumnCodeError";
  }
}

export class InvalidResponseOpenEndedResponsesError extends GetPaginatedOpenEndedResponsesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseOpenEndedResponsesError";
  }
}

export class InvalidResponseTotalItemsError extends GetPaginatedOpenEndedResponsesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTotalItemsError";
  }
}

export class InvalidResponseInvalidProjectIdError extends GetPaginatedOpenEndedResponsesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidProjectIdError";
  }
}

export class InvalidResponseInvalidSurveyIdError extends GetPaginatedOpenEndedResponsesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidSurveyIdError";
  }
}

export class InvalidResponseInvalidSurveyViewIdError extends GetPaginatedOpenEndedResponsesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidSurveyViewIdError";
  }
}

export class InvalidResponseInvalidQuestionViewIdError extends GetPaginatedOpenEndedResponsesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidQuestionViewIdError";
  }
}

export class InvalidResponseInvalidPageIndexError extends GetPaginatedOpenEndedResponsesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidPageIndexError";
  }
}

export class InvalidResponseDeletedColumnFilterError extends GetPaginatedOpenEndedResponsesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseDeletedColumnFilterError";
  }
}

export class InvalidResponseIncorrectQuestionTypeError extends GetPaginatedOpenEndedResponsesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseIncorrectQuestionTypeError";
  }
}

